import { sendSecureFile } from 'services/secureDataSharing';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ISecureFileSendPayload } from 'services/secureDataSharing/types';
import { ICommonResponse } from 'services/types';

export const ThunkSendSecureFile = createAsyncThunk<
  ICommonResponse<string>,
  ISecureFileSendPayload
>('secureDataSharing/sendSecureFile', payload => sendSecureFile(payload).then(r => r.data));
